import script from "./PerioGardThree.vue?vue&type=script&setup=true&lang=js"
export * from "./PerioGardThree.vue?vue&type=script&setup=true&lang=js"

import "./PerioGardThree.vue?vue&type=style&index=0&id=a109f566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a109f566"]])

export default __exports__